import API from "@/api";

//上传配置

export default {
	apiObj: API.common.upload,			//上传请求API对象
	filename: "file",					//form请求时文件的key
	successCode: 200,					//请求完成代码
	maxSize: 512,						//最大文件大小 默认10MB
	parseData: function (res) {
		return {
			code: res.status,				//分析状态字段结构
			fileName: res.data.name,//分析文件名称
			src: res.data.path,			//分析图片远程地址结构
			msg: res.message,			//分析描述字段结构
			type: res.data.type,			//分析描述字段结构
			storage_id: res.data.storage_id,		//分析描述字段结构
			ext: res.data.ext,//分析描述字段结构
			size: res.data.size			//分析描述字段结构
		}
	},
	apiObjFile: API.common.uploadFile,	//附件上传请求API对象
	maxSizeFile: 512						//最大文件大小 默认10MB
}
